{
  "AUDIT_LOGS": {
    "HEADER": "Registres d'auditoria",
    "HEADER_BTN_TXT": "Afegeix registres d'auditoria",
    "LOADING": "S'estan recollint registres d'auditoria",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "No hi ha cap resposta que coincideixi amb aquesta consulta",
    "SIDEBAR_TXT": "<p><b>Registres d'auditoria</b> </p><p> Els registres d'auditoria són pistes d'esdeveniments i accions en un sistema. </p>",
    "LIST": {
      "404": "No hi ha registres d'auditoria disponibles en aquest compte.",
      "TITLE": "Gestiona els registres d'auditoria",
      "DESC": "Els registres d'auditoria són pistes d'esdeveniments i accions en el sistema.",
      "TABLE_HEADER": {
        "ACTIVITY": "User",
        "TIME": "Temps",
        "IP_ADDRESS": "Adreça IP"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Els registres d'auditoria s'han recuperat correctament",
      "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
    },
    "DEFAULT_USER": "Sistema",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} ha convidat {invitee} al compte com a {role}",
      "EDIT": {
        "SELF": "{agentName} ha canviat els seus {attributes} a {values}",
        "OTHER": "{agentName} ha canviat {attributes} de {user} a {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} ha iniciat la sessió",
      "SIGN_OUT": "{agentName} ha tancat la sessió"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} ha creat una conversa (#{id})",
      "EDIT": "{agentName} ha actualitzat una conversa (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} ha creat un contacte (#{id})",
      "EDIT": "{agentName} ha actualitzat un contacte (#{id}): {attributes}"
    }
  }
}
